import React from 'react';
import { Form, reduxForm } from 'redux-form';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { EmailPreviewRecipient } from 'stageclip-common';
import classNames from 'classnames';

import Icon from 'components/utils/icon';
import { AppTextField } from 'components/form/appTextField';
import { email as emailValidation } from 'components/form/formValidations';
import { SendPreviewFormProps, SendPreviewFormOnSubmitProps, SendPreviewFormDataProps } from './SendPreviewForm.types';
import styles from './SendPreviewForm.module.scss';

const SendPreviewForm = ({
  sendEmailTemplate,
  handleSubmit,
  pristine,
  submitting,
  templateId,
  valid,
  templateLoading,
}: SendPreviewFormProps) => {
  const onSubmit = ({ email }: EmailPreviewRecipient) => sendEmailTemplate({ recipient: { email }, templateId });
  const isInvalid = pristine || submitting || !templateId || !valid || templateLoading;

  return (
    <Form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex' }}>
      <AppTextField
        name="email"
        placeholder="Send email preview to"
        validate={[emailValidation]}
        hiddenLabel
        className={styles.emailInput}
      />
      <button
        type="submit"
        disabled={isInvalid}
        className={classNames(styles.button, {
          [styles.inactive]: isInvalid,
          [styles.active]: !isInvalid,
        })}
      >
        <Icon icon={faPaperPlane} />
      </button>
    </Form>
  );
};

export const SendPreviewFormContainer = reduxForm<SendPreviewFormDataProps, SendPreviewFormOnSubmitProps>({
  form: 'sendPreview',
  // @ts-ignore
})(SendPreviewForm);
